// extracted by mini-css-extract-plugin
export var editButton = "_oy-0";